/**
 * @module utils/qbLinkage/registry
 * @description QB 联动 handler 注册表 — prune / migrate / sync 各阶段顺序固定
 *
 * sortBy*：X/Y 轴排序；QB 删指标时与 seriesSorts 类似整组回默认；身份改名 migrate chartSorts。
 */

import type { IQBLinkageHandler } from './types';
import { descriptionPruneHandler, descriptionMigrateHandler } from './handlers/description';
import { fieldSettingPruneHandler, fieldSettingMigrateHandler } from './handlers/fieldSetting';
import { statisticsHandler, statisticsMigrateHandler } from './handlers/statistics';
import { columnPercentageHandler } from './handlers/columnPercentage';
import {
  dimensionPercentagePruneHandler,
  dimensionPercentageMigrateHandler,
} from './handlers/dimensionPercentage';
import {
  conditionalFormatHandler,
  conditionalFormatMigrateHandler,
} from './handlers/conditionalFormat';
import { sortByHandler, sortByMigrateHandler } from './handlers/sortBy';
import {
  seriesSortsHandler,
  seriesSortsMigrateHandler,
} from './handlers/seriesSorts';
import { crosstabHandler } from './handlers/crosstab';
import { dualYAxisHandler } from './handlers/dualYAxis';
import { referenceLineHandler } from './handlers/referenceLine';
import { tooltipSettingHandler } from './handlers/tooltipSetting';
import { labelContentHandler } from './handlers/labelContent';
import {
  columnSortReorderHandler,
  columnSortSanitizeHandler,
} from './handlers/columnSort/qbLinkageHandlers';

const HANDLERS: IQBLinkageHandler[] = [
  descriptionPruneHandler,
  fieldSettingPruneHandler,
  statisticsHandler,
  columnPercentageHandler,
  dimensionPercentagePruneHandler,
  conditionalFormatHandler,
  sortByHandler,
  seriesSortsHandler,
  referenceLineHandler,
  tooltipSettingHandler,
  dualYAxisHandler,
  descriptionMigrateHandler,
  fieldSettingMigrateHandler,
  statisticsMigrateHandler,
  sortByMigrateHandler,
  seriesSortsMigrateHandler,
  conditionalFormatMigrateHandler,
  dimensionPercentageMigrateHandler,
  crosstabHandler,
  columnSortReorderHandler,
  columnSortSanitizeHandler,
  labelContentHandler,
];

export function getQBLinkageHandlers(): IQBLinkageHandler[] {
  return HANDLERS;
}

export default HANDLERS;
